export default () => {
  return [
    {
      path: '/redirect',
      name: 'Redirect',
      props: true,
      component: () => import('../../components/application/pages/Redirect.vue')
    },
    {
      path: '/personaldata',
      name: 'PersonalData',
      props: true,
      meta: { section: 'Personal', sectionStartingPage: true, progressionPercentage: { newCustomerFlow: 0 } },
      component: () => import('../../components/application/pages/PersonalData.vue')
    },
    {
      path: '/scanid',
      name: 'ScanId',
      meta: { section: 'Personal', sectionStartingPage: true, progressionPercentage: { newCustomerFlow: 9, returnCustomerFlow: 50 } },
      component: () => import('../../components/application/pages/ScanId.vue')
    },
    {
      path: '/scanidcamera',
      name: 'ScanIdCamera',
      meta: { section: 'Personal', sectionStartingPage: true, progressionPercentage: { newCustomerFlow: 13, returnCustomerFlow: 60 } },
      component: () => import('../../components/application/pages/ScanIdCamera.vue')
    },
    {
      path: '/dateofbirth',
      name: 'DateOfBirth',
      props: true,
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 16 } },
      component: () => import('../../components/application/pages/DateOfBirth.vue')
    },
    {
      path: '/tin',
      name: 'TinEndpoint',
      props: true,
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 22 } },
      component: () => import('../../components/application/pages/Tin.vue')
    },
    {
      path: '/communication',
      name: 'Communication',
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 28 } },
      component: () => import('../../components/application/pages/Communication.vue')
    },
    {
      path: '/passwordform',
      name: 'ApplicationPasswordForm',
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 36 } },
      component: () => import('../../components/common/pages/Register.vue')
    },
    {
      path: '/borrowamount',
      name: 'BorrowAmount',
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 63, returnCustomerFlow: 0 } },
      component: () => import('../../components/application/pages/BorrowAmount.vue')
    },
    {
      path: '/loanselection',
      name: 'LoanTypeSelection',
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 68, returnCustomerFlow: 25 } },
      component: () => import('../../components/application/pages/LoanTypeSelection.vue')
    },
    {
      path: '/address',
      name: 'CustomerAddress',
      props: true,
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 72 } },
      component: () => import('../../components/application/pages/CustomerAddress.vue')
    },
    {
      path: '/mailingaddress',
      name: 'CustomerAddressMailing',
      props: true,
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 77 } },
      component: () => import('../../components/application/pages/CustomerAddressMailing.vue')
    },
    {
      path: '/idselection',
      name: 'IdSelection',
      props: true,
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 81 } },
      component: () => import('../../components/application/pages/IdSelection.vue')
    },
    {
      path: '/driverslicense',
      name: 'IdDriversLicense',
      props: true,
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 85 } },
      component: () => import('../../components/application/pages/IdDriversLicense.vue')
    },
    {
      path: '/stateid',
      name: 'IdState',
      props: true,
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 85 } },
      component: () => import('../../components/application/pages/IdState.vue')
    },
    {
      path: '/passport',
      name: 'IdPassport',
      props: true,
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 85 } },
      component: () => import('../../components/application/pages/IdPassport.vue')
    },
    {
      path: '/consularid',
      name: 'IdMatriculaConsular',
      props: true,
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 85 } },
      component: () => import('../../components/application/pages/IdMatriculaConsular.vue')
    },
    {
      path: '/maritalstatus',
      name: 'MaritalStatusForm',
      props: true,
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 90 } },
      component: () => import('../../components/application/pages/MaritalStatusForm.vue')
    },
    {
      path: '/spouse',
      name: 'MaritalSpouseForm',
      props: true,
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 92 } },
      component: () => import('../../components/application/pages/MaritalSpouseForm.vue')
    },
    {
      path: '/demographics',
      name: 'DemographicsForm',
      props: true,
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 95 } },
      component: () => import('../../components/application/pages/DemographicsForm.vue')
    },
    {
      path: '/financialbackground',
      name: 'FinancialBackground',
      meta: { section: 'Financial', sectionStartingPage: true, progressionPercentage: { newCustomerFlow: 0, returnCustomerFlow: 0 } },
      component: () => import('../../components/application/pages/FinancialBackground.vue')
    },
    {
      path: '/incomeprimary',
      name: 'IncomePrimary',
      meta: { section: 'Financial', progressionPercentage: { newCustomerFlow: 25, returnCustomerFlow: 25 } },
      props: true,
      component: () => import('../../components/application/pages/IncomePrimary.vue')
    },
    {
      path: '/incomedetails',
      name: 'IncomeDetails',
      props: true,
      meta: { section: 'Financial', progressionPercentage: { newCustomerFlow: 50, returnCustomerFlow: 50 } },
      component: () => import('../../components/application/pages/IncomeDetails.vue')
    },
    {
      path: '/incomesummary',
      name: 'IncomeSummary',
      meta: { section: 'Financial', progressionPercentage: { newCustomerFlow: 75, returnCustomerFlow: 75 } },
      component: () => import('../../components/application/pages/IncomeSummary.vue')
    },
    {
      path: '/incomeexpenses',
      name: 'IncomeExpenses',
      props: true,
      meta: { section: 'Financial', progressionPercentage: { newCustomerFlow: 100, returnCustomerFlow: 100 } },
      component: () => import('../../components/application/pages/IncomeExpenses.vue')
    },
    {
      path: '/financialsummary',
      name: 'FinancialSummary',
      meta: { section: 'Financial', progressionPercentage: { returnCustomerFlow: 0 } },
      component: () => import('../../components/application/pages/FinancialSummary.vue')
    },
    {
      path: '/vehicledetails',
      name: 'VehicleDetails',
      meta: { section: 'Vehicle', sectionStartingPage: true, progressionPercentage: { newCustomerFlow: 0, returnCustomerFlow: 0 } },
      component: () => import('../../components/application/pages/VehicleDetails.vue')
    },
    {
      path: '/vehicleworth',
      name: 'VehicleWorth',
      meta: { section: 'Vehicle', progressionPercentage: { newCustomerFlow: 33, returnCustomerFlow: 33 } },
      component: () => import('../../components/application/pages/VehicleWorth.vue')
    },
    {
      path: '/cpp',
      name: 'CollateralProtection',
      meta: { section: 'Complete' },
      component: () => import('../../components/application/pages/CollateralProtection.vue')
    },
    {
      path: '/ownorfinancevehicle',
      name: 'OwnOrFinanceVehicle',
      meta: { section: 'Vehicle', progressionPercentage: { newCustomerFlow: 66, returnCustomerFlow: 66 } },
      component: () => import('../../components/application/pages/OwnOrFinanceVehicle.vue')
    },
    {
      path: '/vehicleLender',
      name: 'VehicleLenderInfo',
      meta: {
        section: 'Vehicle',
        progressionPercentage: {
          newCustomerFlow: 75,
          returnCustomerFlow: 75
        }
      },
      component: () => import('../../components/application/pages/CaptureVehicleLenderInformation.vue')
    },
    {
      path: '/vehiclecoownerselect',
      name: 'VehicleCoOwnerSelect',
      meta: { section: 'Vehicle', progressionPercentage: { newCustomerFlow: 82, returnCustomerFlow: 82 } },
      component: () => import('../../components/application/pages/VehicleCoOwnerSelect.vue')
    },
    {
      path: '/vehiclecoownername',
      name: 'VehicleCoOwnerName',
      meta: { section: 'Vehicle', progressionPercentage: { newCustomerFlow: 95, returnCustomerFlow: 95 } },
      component: () => import('../../components/application/pages/VehicleCoOwnerName.vue')
    },
    {
      path: '/bankinginformation',
      name: 'BankingInformation',
      meta: { section: 'Banking', sectionStartingPage: true, progressionPercentage: { newCustomerFlow: 0, returnCustomerFlow: 0 } },
      component: () => import('../../components/application/pages/BankingInformation.vue')
    },
    {
      path: '/phone',
      name: 'PhoneNumber',
      meta: { section: 'Personal', progressionPercentage: { newCustomerFlow: 95, returnCustomerFlow: 95 } },
      component: () => import('../../components/application/pages/ApplicationPhoneNumber.vue')
    },
    {
      path: '/disclosures',
      name: 'Disclosures',
      meta: { section: 'Complete' },
      component: () => import('../../components/application/pages/Disclosures.vue')
    },
    {
      path: '/submitapplication',
      name: 'SubmitApplication',
      meta: { section: 'Complete' },
      component: () => import('../../components/application/pages/SubmitApplication.vue')
    },
    {
      path: '/summary',
      name: 'PersonalInfoSummary',
      meta: { section: 'Personal', progressionPercentage: { returnCustomerFlow: 75 } },
      component: () => import('../../components/application/pages/PersonalInfoSummary.vue')
    },
    {
      path: '/loanstatusdenial',
      name: 'LoanDenial',
      props: true,
      meta: {
        section: 'NONE',
        skipAuthTimeout: true
      },
      component: () => import('../../components/application/pages/LoanDenial.vue')
    },
    {
      path: '/loanstatusapproval',
      name: 'LoanApproval',
      meta: {
        section: 'NONE',
        fullWidthLayout: true
      },
      component: () => import('../../components/application/pages/LoanApproval.vue')
    },
    {
      path: '/loanreview',
      name: 'LoanReview',
      meta: {
        section: 'NONE',
        fullWidthLayout: true
      },
      component: () => import('../../components/application/pages/LoanReview.vue')
    },
    {
      path: '/offerassist',
      name: 'LoanOfferAssist',
      meta: {
        section: 'NONE',
        fullWidthLayout: true
      },
      component: () => import('../../components/application/pages/LoanOfferAssist.vue')
    },
    {
      path: '/activeloan',
      name: 'LoanActive',
      meta: { section: 'NONE' },
      component: () => import('../../components/application/pages/LoanActive.vue')
    },
    {
      path: '/appointmentonly',
      name: 'AppointmentOnly',
      meta: { section: 'NONE', fullWidthLayout: true },
      component: () => import('../../components/application/pages/AppointmentOnly.vue')
    },
    {
      path: '/downloadassessmentfasttrackweb',
      name: 'DownloadAssessmentFastTrackWeb',
      meta: { section: 'Appraisal', progressionPercentage: { newCustomerFlow: 99, returnCustomerFlow: 99 }, grayBackground: true, swirlyBackground: true },
      component: () => import('../../components/application/pages/DownloadAssessmentFastTrackWeb.vue')
    },
    {
      path: '/scheduleappointment',
      name: 'ScheduleAppointment',
      props: true,
      meta: { section: 'NONE', fullWidthLayout: true },
      component: () => import('../../components/application/pages/ScheduleAppointment.vue')
    },
    {
      path: '/confirmappointment',
      name: 'ScheduleConfirm',
      meta: {
        section: 'NONE',
        fullWidthLayout: true,
        grayBackground: true
      },
      props: true,
      component: () => import('../../components/application/pages/ScheduleConfirm.vue')
    },
    {
      path: '/changestore',
      name: 'ScheduleChangeStore',
      meta: { section: 'NONE' },
      props: true,
      component: () => import('../../components/application/pages/ScheduleChangeStore.vue')
    },
    {
      path: '/oops',
      name: 'OopsPage',
      meta: {
        section: 'NONE',
        skipAuthTimeout: true
      },
      component: () => import('../../components/application/pages/OopsPage.vue')
    },
    {
      path: '/locationpermissionconfirm',
      name: 'LocationPermissionConfirm',
      props: true,
      meta: { section: 'NONE' },
      component: () => import('../../components/application/pages/LocationPermissionConfirm.vue')
    },
    {
      path: '/locationpermissionblocked',
      name: 'LocationPermissionBlocked',
      meta: { section: 'NONE' },
      component: () => import('../../components/application/pages/LocationPermissionBlocked.vue')
    },
    {
      path: '/scanidsuccess',
      name: 'ScanIdSuccess',
      meta: { section: 'NONE' },
      component: () => import('../../components/application/pages/ScanIdSuccess.vue')
    }
  ]
}
